import * as React from 'react';
import { Container, Button, Col, Row } from 'reactstrap';
import './Contact.css';
import * as Scroll from 'react-scroll';

export class Contact extends React.Component<any,{}> {

  render() {

    return (
      <section className="page-section" id="contact-section">
        <Scroll.Element name="contact">
          <Container tag="article" className="clients-container">
            <header className="section-header">
              <Row>
                <Col xs="12">
                  <h1>Ota yhteyttä</h1>
                  <p className="lead">Etsitkö sitoutunutta, innostunutta ja asiantuntevaa kumppania?<br /> Soita, lähetä sähköpostia ja sovitaan tapaaminen. Kuuntelemme ja kerromme kuinka voimme auttaa.</p>
                </Col>
              </Row>
            </header>
            <Container  className="contact-company">
              <div className="contact-card">
                <div className="vcard">
                  <h2 className="fn org">Muotoilutoimisto Kairo Oy</h2>
                  <ul className="p-0">
                    <li className="street-address">Kuusitie 14 A 27</li>
                    <li><span className="postal-code">00270</span> <span className="locality">Helsinki</span></li>
                    <li><a href="mailto:kairo@kairo.fi" className="email">kairo@kairo.fi</a></li>
                    <li><a href="tel:0407556886">040 755 6886</a></li>
                  </ul>
                </div>
                <ul className="contact-buttons">
                  <li><a href="mailto:kairo@kairo.fi"><Button color="primary" className="mb-2">Lähetä tiedustelu</Button></a></li>
                  <li><a href="mailto:kairo@kairo.fi"><Button color="primary" className="mb-2">Hae töihin</Button></a></li>
                </ul>
              </div>
            </Container>
          </Container>
        </Scroll.Element>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/contact/Contact.tsx